import { render, staticRenderFns } from "./M_versionManagement.vue?vue&type=template&id=cf8d0002&scoped=true&"
import script from "./M_versionManagement.vue?vue&type=script&lang=js&"
export * from "./M_versionManagement.vue?vue&type=script&lang=js&"
import style0 from "./M_versionManagement.vue?vue&type=style&index=0&id=cf8d0002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d0002",
  null
  
)

export default component.exports